import {useState} from 'react'
import MarketDetailsForm from './MarketDetailsForm';
import MarketDetailsList from './MarketDetailsList';

const MarketDetails = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
  return (
    <>
      {fromIsShown ? (
          <MarketDetailsForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <MarketDetailsList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default MarketDetails